"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePreDefinedMsgUsed = exports.loadUpdatePreDefinedMsgUsed = void 0;
var _types = require("./types");
var _selectors = require("../selectors");
// ====================================================================
// Typed actions
// ====================================================================

var loadUpdatePreDefinedMsgUsed = exports.loadUpdatePreDefinedMsgUsed = function loadUpdatePreDefinedMsgUsed(messageText, roomname) {
  return {
    type: _types.UPDATE_PRE_DEFINED_MESSAGE_USED,
    value: {
      messageText: messageText,
      roomname: roomname
    }
  };
};
var updatePreDefinedMsgUsed = exports.updatePreDefinedMsgUsed = function updatePreDefinedMsgUsed(messageText) {
  return function (dispatch, getState) {
    var state = getState();
    var roomname = (0, _selectors.getCurrentRoomname)(state);
    dispatch(loadUpdatePreDefinedMsgUsed(messageText, roomname));
  };
};